<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :content="page.content">
			<template #extra-content>
				<book-button v-if="page.bookingID" :packageid="page.bookingID" class="button cta">
					<span>{{ $t('bookThisPackage') }}</span>
				</book-button>
				<nuxt-link class="button no-fill" :to="localePath('packages', locale)">
					{{ $t('buttonReturnToOverview') }}
				</nuxt-link>
			</template>
		</main-content>

		<section v-if="page.overviewImages" class="main-content contentblocks background-light">
			<div class="row contentblock">
				<content-block
					:image="page.overviewImages[0]"
					:image-webp="page.overviewImagesWebp[0]"
					:image-alt="page.overviewImageAlt"
					:content="page.contentExtra"
				/>
			</div>
		</section>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();
const localePath = useLocalePath();

await fetchPage();
</script>

<style lang="scss">
.package-prefooter {
	padding: 50px 0;
	background: var(--secondary-background-color);
	color: #fff;
}

.package-prefooter h2 {
	color: #fff;
}

.extra-image {
	width: 100%;
	max-width: 600px;
	margin: 20px auto 0;
}

.package-icons {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: stretch;
}

.package-icon {
	width: 46%;
	background: #fff;
	padding: 40px 30px;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	text-align: center;
	margin: 10px auto;
}

.package-icon i,
.package-icon svg {
	color: var(--cta-color);
	font-size: 66px;
	margin: 0 auto 40px;
}

.package-icon span {
	width: 100%;
	font-size: 18px;
}

@media (max-width: 920px) {
	.package-icons {
		width: 100%;
	}
}

@media (max-width: 680px) {
	.package-icon {
		padding: 30px 20px;
		width: 48%;
	}

	.package-icon i,
	.package-icon svg {
		font-size: 58px;
	}

	.package-icon span {
		font-size: 16px;
	}
}
</style>
